export enum WindDirection{
    East,
    South,
    West,
    North,
    Unassigned
}
